/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DtoVehicleBaseResponse as LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse } from '../models/Limelight/Babylon/DataObjects/DTO/dto-vehicle-base-response';
import { DtoVehicleBasicBaseResponse as LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse } from '../models/Limelight/Babylon/DataObjects/DTO/dto-vehicle-basic-base-response';
import { ApplicationResponseBaseResponse as ModelsV4ApplicationApplicationResponseBaseResponse } from '../models/Models/v4/Application/application-response-base-response';
import { ApplicationUpdateVehicleResponseBaseResponse as ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse } from '../models/Models/v4/Application/Public/application-update-vehicle-response-base-response';
import { BooleanBaseResponse as SystemBooleanBaseResponse } from '../models/System/boolean-base-response';
import { v4PublicApplicationVehicleApplicationIdPut$Json } from '../fn/public-vehicle-application/v-4-public-application-vehicle-application-id-put-json';
import { V4PublicApplicationVehicleApplicationIdPut$Json$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-application-id-put-json';
import { v4PublicApplicationVehicleApplicationIdPut$Plain } from '../fn/public-vehicle-application/v-4-public-application-vehicle-application-id-put-plain';
import { V4PublicApplicationVehicleApplicationIdPut$Plain$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-application-id-put-plain';
import { v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Json } from '../fn/public-vehicle-application/v-4-public-application-vehicle-application-id-vehicle-info-get-json';
import { V4PublicApplicationVehicleApplicationIdVehicleInfoGet$Json$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-application-id-vehicle-info-get-json';
import { v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain } from '../fn/public-vehicle-application/v-4-public-application-vehicle-application-id-vehicle-info-get-plain';
import { V4PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-application-id-vehicle-info-get-plain';
import { v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Xml } from '../fn/public-vehicle-application/v-4-public-application-vehicle-application-id-vehicle-info-get-xml';
import { V4PublicApplicationVehicleApplicationIdVehicleInfoGet$Xml$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-application-id-vehicle-info-get-xml';
import { v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Json } from '../fn/public-vehicle-application/v-4-public-application-vehicle-application-id-vehicle-lookup-get-json';
import { V4PublicApplicationVehicleApplicationIdVehicleLookupGet$Json$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-application-id-vehicle-lookup-get-json';
import { v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Plain } from '../fn/public-vehicle-application/v-4-public-application-vehicle-application-id-vehicle-lookup-get-plain';
import { V4PublicApplicationVehicleApplicationIdVehicleLookupGet$Plain$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-application-id-vehicle-lookup-get-plain';
import { v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Xml } from '../fn/public-vehicle-application/v-4-public-application-vehicle-application-id-vehicle-lookup-get-xml';
import { V4PublicApplicationVehicleApplicationIdVehicleLookupGet$Xml$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-application-id-vehicle-lookup-get-xml';
import { v4PublicApplicationVehiclePingGet$Json } from '../fn/public-vehicle-application/v-4-public-application-vehicle-ping-get-json';
import { V4PublicApplicationVehiclePingGet$Json$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-ping-get-json';
import { v4PublicApplicationVehiclePingGet$Plain } from '../fn/public-vehicle-application/v-4-public-application-vehicle-ping-get-plain';
import { V4PublicApplicationVehiclePingGet$Plain$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-ping-get-plain';
import { v4PublicApplicationVehiclePingGet$Xml } from '../fn/public-vehicle-application/v-4-public-application-vehicle-ping-get-xml';
import { V4PublicApplicationVehiclePingGet$Xml$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-ping-get-xml';
import { v4PublicApplicationVehiclePost$Json$Json } from '../fn/public-vehicle-application/v-4-public-application-vehicle-post-json-json';
import { V4PublicApplicationVehiclePost$Json$Json$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-post-json-json';
import { v4PublicApplicationVehiclePost$Json$Plain } from '../fn/public-vehicle-application/v-4-public-application-vehicle-post-json-plain';
import { V4PublicApplicationVehiclePost$Json$Plain$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-post-json-plain';
import { v4PublicApplicationVehiclePost$Json$Xml } from '../fn/public-vehicle-application/v-4-public-application-vehicle-post-json-xml';
import { V4PublicApplicationVehiclePost$Json$Xml$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-post-json-xml';
import { v4PublicApplicationVehiclePost$Xml$Json } from '../fn/public-vehicle-application/v-4-public-application-vehicle-post-xml-json';
import { V4PublicApplicationVehiclePost$Xml$Json$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-post-xml-json';
import { v4PublicApplicationVehiclePost$Xml$Plain } from '../fn/public-vehicle-application/v-4-public-application-vehicle-post-xml-plain';
import { V4PublicApplicationVehiclePost$Xml$Plain$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-post-xml-plain';
import { v4PublicApplicationVehiclePost$Xml$Xml } from '../fn/public-vehicle-application/v-4-public-application-vehicle-post-xml-xml';
import { V4PublicApplicationVehiclePost$Xml$Xml$Params } from '../fn/public-vehicle-application/v-4-public-application-vehicle-post-xml-xml';

@Injectable({ providedIn: 'root' })
export class PublicVehicleApplicationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v4PublicApplicationVehiclePingGet()` */
  static readonly V4PublicApplicationVehiclePingGetPath = '/v4/public/application/vehicle/ping';

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehiclePingGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehiclePingGet$Plain$Response(params?: V4PublicApplicationVehiclePingGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemBooleanBaseResponse>> {
    return v4PublicApplicationVehiclePingGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehiclePingGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehiclePingGet$Plain(params?: V4PublicApplicationVehiclePingGet$Plain$Params, context?: HttpContext): Observable<SystemBooleanBaseResponse> {
    return this.v4PublicApplicationVehiclePingGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemBooleanBaseResponse>): SystemBooleanBaseResponse => r.body)
    );
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehiclePingGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehiclePingGet$Json$Response(params?: V4PublicApplicationVehiclePingGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemBooleanBaseResponse>> {
    return v4PublicApplicationVehiclePingGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehiclePingGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehiclePingGet$Json(params?: V4PublicApplicationVehiclePingGet$Json$Params, context?: HttpContext): Observable<SystemBooleanBaseResponse> {
    return this.v4PublicApplicationVehiclePingGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemBooleanBaseResponse>): SystemBooleanBaseResponse => r.body)
    );
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehiclePingGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehiclePingGet$Xml$Response(params?: V4PublicApplicationVehiclePingGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemBooleanBaseResponse>> {
    return v4PublicApplicationVehiclePingGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Authenticated Ping - returns 1 if authenticated and with customer portal role.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehiclePingGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehiclePingGet$Xml(params?: V4PublicApplicationVehiclePingGet$Xml$Params, context?: HttpContext): Observable<SystemBooleanBaseResponse> {
    return this.v4PublicApplicationVehiclePingGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemBooleanBaseResponse>): SystemBooleanBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4PublicApplicationVehiclePost()` */
  static readonly V4PublicApplicationVehiclePostPath = '/v4/public/application/vehicle';

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehiclePost$Json$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationVehiclePost$Json$Plain$Response(params?: V4PublicApplicationVehiclePost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4PublicApplicationVehiclePost$Json$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehiclePost$Json$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationVehiclePost$Json$Plain(params?: V4PublicApplicationVehiclePost$Json$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4PublicApplicationVehiclePost$Json$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehiclePost$Json$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationVehiclePost$Json$Json$Response(params?: V4PublicApplicationVehiclePost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4PublicApplicationVehiclePost$Json$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehiclePost$Json$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationVehiclePost$Json$Json(params?: V4PublicApplicationVehiclePost$Json$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4PublicApplicationVehiclePost$Json$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehiclePost$Json$Xml()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationVehiclePost$Json$Xml$Response(params?: V4PublicApplicationVehiclePost$Json$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4PublicApplicationVehiclePost$Json$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehiclePost$Json$Xml$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationVehiclePost$Json$Xml(params?: V4PublicApplicationVehiclePost$Json$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4PublicApplicationVehiclePost$Json$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehiclePost$Xml$Plain()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4PublicApplicationVehiclePost$Xml$Plain$Response(params?: V4PublicApplicationVehiclePost$Xml$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4PublicApplicationVehiclePost$Xml$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehiclePost$Xml$Plain$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4PublicApplicationVehiclePost$Xml$Plain(params?: V4PublicApplicationVehiclePost$Xml$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4PublicApplicationVehiclePost$Xml$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehiclePost$Xml$Json()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4PublicApplicationVehiclePost$Xml$Json$Response(params?: V4PublicApplicationVehiclePost$Xml$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4PublicApplicationVehiclePost$Xml$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehiclePost$Xml$Json$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4PublicApplicationVehiclePost$Xml$Json(params?: V4PublicApplicationVehiclePost$Xml$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4PublicApplicationVehiclePost$Xml$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehiclePost$Xml$Xml()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4PublicApplicationVehiclePost$Xml$Xml$Response(params?: V4PublicApplicationVehiclePost$Xml$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>> {
    return v4PublicApplicationVehiclePost$Xml$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Starts new Vehicle application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehiclePost$Xml$Xml$Response()` instead.
   *
   * This method sends `application/*+xml` and handles request body of type `application/*+xml`.
   */
  v4PublicApplicationVehiclePost$Xml$Xml(params?: V4PublicApplicationVehiclePost$Xml$Xml$Params, context?: HttpContext): Observable<ModelsV4ApplicationApplicationResponseBaseResponse> {
    return this.v4PublicApplicationVehiclePost$Xml$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationApplicationResponseBaseResponse>): ModelsV4ApplicationApplicationResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4PublicApplicationVehicleApplicationIdPut()` */
  static readonly V4PublicApplicationVehicleApplicationIdPutPath = '/v4/public/application/vehicle/{applicationId}';

  /**
   * Update the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehicleApplicationIdPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationVehicleApplicationIdPut$Plain$Response(params: V4PublicApplicationVehicleApplicationIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>> {
    return v4PublicApplicationVehicleApplicationIdPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehicleApplicationIdPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationVehicleApplicationIdPut$Plain(params: V4PublicApplicationVehicleApplicationIdPut$Plain$Params, context?: HttpContext): Observable<ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse> {
    return this.v4PublicApplicationVehicleApplicationIdPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>): ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse => r.body)
    );
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehicleApplicationIdPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationVehicleApplicationIdPut$Json$Response(params: V4PublicApplicationVehicleApplicationIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>> {
    return v4PublicApplicationVehicleApplicationIdPut$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the application.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehicleApplicationIdPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v4PublicApplicationVehicleApplicationIdPut$Json(params: V4PublicApplicationVehicleApplicationIdPut$Json$Params, context?: HttpContext): Observable<ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse> {
    return this.v4PublicApplicationVehicleApplicationIdPut$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse>): ModelsV4ApplicationPublicApplicationUpdateVehicleResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4PublicApplicationVehicleApplicationIdVehicleLookupGet()` */
  static readonly V4PublicApplicationVehicleApplicationIdVehicleLookupGetPath = '/v4/public/application/vehicle/{applicationId}/vehicleLookup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Plain$Response(params: V4PublicApplicationVehicleApplicationIdVehicleLookupGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse>> {
    return v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Plain(params: V4PublicApplicationVehicleApplicationIdVehicleLookupGet$Plain$Params, context?: HttpContext): Observable<LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse> {
    return this.v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse>): LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Json$Response(params: V4PublicApplicationVehicleApplicationIdVehicleLookupGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse>> {
    return v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Json(params: V4PublicApplicationVehicleApplicationIdVehicleLookupGet$Json$Params, context?: HttpContext): Observable<LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse> {
    return this.v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse>): LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Xml$Response(params: V4PublicApplicationVehicleApplicationIdVehicleLookupGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse>> {
    return v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Xml(params: V4PublicApplicationVehicleApplicationIdVehicleLookupGet$Xml$Params, context?: HttpContext): Observable<LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse> {
    return this.v4PublicApplicationVehicleApplicationIdVehicleLookupGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse>): LimelightBabylonDataObjectsDtoDtoVehicleBasicBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4PublicApplicationVehicleApplicationIdVehicleInfoGet()` */
  static readonly V4PublicApplicationVehicleApplicationIdVehicleInfoGetPath = '/v4/public/application/vehicle/{applicationId}/vehicle/info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain$Response(params: V4PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse>> {
    return v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain(params: V4PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain$Params, context?: HttpContext): Observable<LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse> {
    return this.v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse>): LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Json$Response(params: V4PublicApplicationVehicleApplicationIdVehicleInfoGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse>> {
    return v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Json(params: V4PublicApplicationVehicleApplicationIdVehicleInfoGet$Json$Params, context?: HttpContext): Observable<LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse> {
    return this.v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse>): LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Xml$Response(params: V4PublicApplicationVehicleApplicationIdVehicleInfoGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse>> {
    return v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Xml(params: V4PublicApplicationVehicleApplicationIdVehicleInfoGet$Xml$Params, context?: HttpContext): Observable<LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse> {
    return this.v4PublicApplicationVehicleApplicationIdVehicleInfoGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse>): LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse => r.body)
    );
  }

}
